module.exports = __webpack_public_path__ + "static/media/390x310-Roterdam.7e56d736.jpg";